import React from 'react'
import { Routes, Route, Link } from 'react-router-dom';
import Major_2020 from '../2020/Major_2020';
import Major_2021 from '../2021/Major_2021';
import Major_2022 from '../2022/Major_2022';
import Major_2023 from '../2023/Major_2023';
import winterdata2022 from '../2022/Winter Internship_2022';
import mpdata2020 from '../2020/Winter Internship_2020';
import mpdata2021 from '../2021/Winter Internship_2021';
import mpdata2023 from '../2023/Winter Internship_2023';

const Major = () => {
  return (

    <div>
   
    <div className='myheader'>
    <button className='merabtn'>
  <span>Major Projects</span><i></i>
  </button>
    </div>
 




    <div> 
    <div className='myclass'>
         
            <Link to="/mp/2023">
                <div className='menuLink'>
                2023
                </div>
            </Link>

            <Link to="/mp/2022">
                <div className='menuLink'>
                    2022
                </div>               
            </Link>

            <Link to="/mp/2021"> 
              <div className='menuLink'>
                2021
              </div>
            </Link>

            <Link to="/mp/2020"> 
              <div className='menuLink'>
                2020
              </div>
            </Link>


    </div> 
    {/*<div className='andarwaladiv'>*/}
       
  <Routes>
  
    <Route exact path="2023" element={<Major_2023 data={mpdata2023} />} />
    <Route exact path="2022" element={<Major_2022 data={winterdata2022} />} />
    <Route exact path="2021" element={<Major_2021 data = {mpdata2021} />} />
    <Route exact path="2020" element={<Major_2020 data = {mpdata2020} />} />
 

  </Routes>
   {/*</div>*/}
  </div>
 
  </div>

  )
}

export default Major